/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Grok_AddInputs */

const en_mcp_grok_add = /** @type {(inputs: Mcp_Grok_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose New Connector, then Custom, and paste the MCP URL.`)
};

const es_mcp_grok_add = /** @type {(inputs: Mcp_Grok_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige New Connector, luego Custom, y pega la URL de MCP.`)
};

/**
* | output |
* | --- |
* | "Choose New Connector, then Custom, and paste the MCP URL." |
*
* @param {Mcp_Grok_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_grok_add = /** @type {((inputs?: Mcp_Grok_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Grok_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_grok_add(inputs)
	return en_mcp_grok_add(inputs)
});